import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import Validator from 'validatorjs';
import { Col, Row } from 'react-bootstrap';

import { FormControl } from '../../../../../facturotopia';
import RetencionesCatalogoManager from '../../../../catalogs/managers/RetencionesCatalogoManager';

const ContribucionGubernamentalForm = (props) => {
  const [catalogos, setCatalogos] = useState({});
  const [, setValidator] = useState({
    isValid: false,
    validator: new Validator(),
  });

  useEffect(() => {
    const loadCatalogs = async () => {
      const EntidadDondePagaLaContribucion = await RetencionesCatalogoManager.get('r_entidad_federativa');

      const catalogos = {};

      catalogos.EntidadDondePagaLaContribucion = await syncCatalog(EntidadDondePagaLaContribucion);

      setCatalogos(catalogos);
    };

    loadCatalogs();
  }, []);

  const syncCatalog = async (values) => {
    if (!!values) {
      const sorted = _.sortBy(
        values.map((item) => {
          return {
            label: item.descripcion,
            value: item.clave,
          };
        }),
        'label'
      );

      return [
        {
          label: 'Selecciona',
          value: '',
        },
      ].concat(sorted);
    }
  };

  const getRules = (data) => {
    return {
      ImpContrib: ['required', 'decimal:6'],
      EntidadDondePagaLaContribucion: ['required', 'string'],
    };
  };

  const handleOnChange = (event) => {
    const data = {
      ...props.data,
      ...event,
    };

    const validator = validate(data);

    props.onFormDataChange(
      {
        ContribucionGubernamental: data,
      },
      {
        name: 'isValidContribucionGubernamental',
        isValid: validator.passes(),
      }
    );
  };

  const validate = (data) => {
    const validator = new Validator(data, getRules(data));

    validator.check();

    setValidator({
      validator,
      isValid: validator.passes(),
    });

    return validator;
  };

  const { data = {} } = props;
  const rules = getRules(data);

  return (
    <Row>
      <Col
        sm
        md={4}
      >
        <FormControl
          type="number"
          label="ImpContrib"
          name="ImpContrib"
          placeholder=""
          help=""
          rules={rules.ImpContrib}
          value={data.ImpContrib}
          onChange={handleOnChange}
        />
      </Col>

      <Col
        sm
        md={4}
      >
        <FormControl
          type="select"
          label="EntidadDondePagaLaContribucion"
          name="EntidadDondePagaLaContribucion"
          placeholder=""
          help=""
          minLength="21"
          maxLength="21"
          rules={rules.EntidadDondePagaLaContribucion}
          value={data.EntidadDondePagaLaContribucion}
          options={catalogos.EntidadDondePagaLaContribucion}
          onChange={handleOnChange}
        />
      </Col>
    </Row>
  );
};

export default ContribucionGubernamentalForm;
